export default {
	palette: {
		primary1Color: "#080f21",
		primary2Color: "#202637",
		text1Color: "#fff",
		text2Color: "#8b939b",
		text3Color: "#666",
		alternativeTextColor: "#000",
	}
}


// WEBPACK FOOTER //
// ./src/utils/theme.js